import React from 'react';
import {
  mergeClasses, Text,
} from '@fluentui/react-components';

export const RemainingText = ({
  i18n, className,
}) => {
  const remainingText = i18n.getString(_TL_('Please note you have a limited number of image requests that we can generate quickly each day. After that, image generations may take longer than expected.'));
  return (
    <>
      <div className={mergeClasses(className, 'remainingText')}>
        <Text align="start">{remainingText}</Text>
      </div>
    </>
  );
};
